import { ConvertToEnglish } from "./ConvertToEnglish";
export const TimeToMinutes = (time) => {
  const PersianSupportTime = ConvertToEnglish(time);
  let [hours, minutes] = PersianSupportTime.split(":").map(Number);
  if (time.includes("AM") || time.includes("ق ض")) {
    if (hours === 12) {
      hours = 0;
    }
  } else if (time.includes("PM") || time.includes("ب ظ")) {
    if (hours !== 12) {
      hours += 12;
    }
  }
  return hours * 60 + minutes;
};
